import React,{useState,useEffect} from "react";
import {
Box,
Drawer,
Toolbar,
List,
ListItem,
ListItemIcon,
ListItemText,
Collapse,
Typography,
Avatar,
AppBar,
IconButton,
CssBaseline,
Divider
} from "@mui/material";

import {
Dashboard,
ExpandLess,
ExpandMore,
Logout,
Score,
Edit,
ListAlt,
MenuBook
} from "@mui/icons-material";

import MenuIcon from '@mui/icons-material/Menu';
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

import {Link,Outlet,useLocation,useNavigate} from "react-router-dom";

import avtr from "../assets/avatar.png";

const drawerWidth=240;

export default function StaffLiteDashboard(){

const navigate=useNavigate();
const location=useLocation();

const [marksOpen,setMarksOpen]=useState(false);

const [staffName,setStaffName]=useState("");

const [mobileOpen,setMobileOpen]=useState(false);

useEffect(()=>{

const name=sessionStorage.getItem(
'adminName'
);

if(!name){

navigate('/admin/login');

return;

}

setStaffName(name);

},[]);

const handleLogout=()=>{

sessionStorage.clear();

navigate('/admin/login');

};

const sidebar=(

<Box>

<Toolbar/>

<Box sx={{
textAlign:'center',
p:2
}}>

<Avatar
src={avtr}
sx={{
width:70,
height:70,
mx:'auto',
mb:1
}}
/>

<Typography
variant="h6"
>

Welcome

</Typography>

<Typography
fontWeight="bold"
>

{staffName}

</Typography>

<Typography
variant="body2"
color="gray"
>

Staff User

</Typography>

</Box>

<Divider/>

<List>

<ListItem
button
component={Link}
to="/staff/home"
selected={
location.pathname==="/staff/home"
}
>

<ListItemIcon>

<Dashboard color="primary"/>

</ListItemIcon>

<ListItemText
primary="Staff Dashboard"
/>

</ListItem>

<ListItem
button
onClick={()=>
setMarksOpen(!marksOpen)
}
>

<ListItemIcon>

<MenuBook color="success"/>

</ListItemIcon>

<ListItemText
primary="Marks"
/>

{
marksOpen
?
<ExpandLess/>
:
<ExpandMore/>
}

</ListItem>

<Collapse
in={marksOpen}
>

<List>

<ListItem
button
component={Link}
to="/staff/markspagelist"
sx={{pl:4}}
>

<ListItemIcon>

<ListAlt color="info"/>

</ListItemIcon>

<ListItemText
primary="Marks List"
/>

</ListItem>
<ListItem
button
component={Link}
to="/staff/homework"
>
<ListItemIcon>
<AssignmentTurnedInIcon color="warning"/>
</ListItemIcon>

<ListItemText
primary="Homework"
/>

</ListItem>
{/* <ListItem
button
component={Link}
to="/staff/markseditpage"
sx={{pl:4}}
>

<ListItemIcon>

<Edit color="warning"/>

</ListItemIcon>

<ListItemText
primary="Edit Marks"
/>

</ListItem> */}

</List>

</Collapse>

<ListItem
button
onClick={handleLogout}
>

<ListItemIcon>

<Logout color="error"/>

</ListItemIcon>

<ListItemText
primary="Logout"
/>

</ListItem>

</List>

</Box>

);

return(

<Box sx={{
display:'flex'
}}>

<CssBaseline/>

<AppBar
position="fixed"
sx={{
zIndex:1201,
background:"#1976d2"
}}
>

<Toolbar>

<IconButton
color="inherit"
edge="start"
onClick={()=>
setMobileOpen(!mobileOpen)
}
sx={{
mr:2,
display:{
xs:'block',
md:'none'
}
}}
>

<MenuIcon/>

</IconButton>

<Typography
variant="h6"
sx={{
flexGrow:1
}}
>

Staff Dashboard

</Typography>

<Avatar
src={avtr}
/>

<Box sx={{ml:2}}>

<Typography>

{staffName}

</Typography>

</Box>

</Toolbar>

</AppBar>

<Drawer
variant="permanent"
sx={{
width:drawerWidth,
display:{
xs:'none',
md:'block'
},
"& .MuiDrawer-paper":{
width:drawerWidth
}
}}
>

{sidebar}

</Drawer>

<Drawer
variant="temporary"
open={mobileOpen}
onClose={()=>
setMobileOpen(false)
}
sx={{
display:{
xs:'block',
md:'none'
},
"& .MuiDrawer-paper":{
width:drawerWidth
}
}}
>

{sidebar}

</Drawer>

<Box
component="main"
sx={{
flexGrow:1,
p:3,
background:"#f4f6f9",
minHeight:"100vh"
}}
>

<Toolbar/>

<Outlet/>

</Box>

</Box>

);

}